import api from "@/lib/axios";
import { queryClient } from "@/lib/queryClient";
import useAuth from "@/hooks/stores/useAuth";
import { heartbeatService } from "./heartbeatService";

export const authService = {
  async login(data) {
    const response = await api.post('/login', data);
    const { data: responseData, meta } = response.data;
    console.log('responseData', responseData)
    const user = responseData.user.name;
    console.log('user', user)
    const userId = responseData.user.id;
    const accessToken = meta.access_token;
    const refreshToken = meta.refresh_token;
    const userRole = responseData.user.roles[0].title;
    console.log('User role from login:', userRole);
    
    const { setTokens, setUserRole } = useAuth.getState();
    setTokens(accessToken, refreshToken, userId);
    setUserRole(userRole);

    // Start heartbeat if user role is 'user'
    console.log('Starting heartbeat service after login...');
    heartbeatService.startHeartbeat();

    return response.data;
  },

  async register(data) {
    const response = await api.post('/register', data);
    const { user, auth_token } = response.data; // Adjusted to match your API response

    // Use auth_token instead of access_token
    // const { setTokens } = useAuth.getState();
    // setTokens(auth_token, null, user.id); // Pass user.id if needed

    return response.data;
  },

  async refreshToken(refreshToken) {
    try {
      const response = await api.post("/auth/refresh-token", { refreshToken });
      return response.data;
    } catch (error) {
      throw new Error("Token refresh failed: " + error.message);
    }
  },

  async getProfile() {
    try {
      const { userId } = useAuth.getState();
      if (!userId) throw new Error("User ID not found");
      
      const response = await api.get(`/v1/get-user-data?user_id=${userId}`);
      return response.data;
    } catch (error) {
      throw new Error("Failed to fetch profile: " + error.message);
    }
  },

  async logout() {
    try {
      // Stop heartbeat before logging out
      heartbeatService.stopHeartbeat();
      
      // First, make the API call to invalidate the session
      await api.post('/v1/logout');
      
      // Then clear local state
      const { clearTokens } = useAuth.getState();
      clearTokens();
      queryClient.clear();
    } catch (error) {
      // Even if the API call fails, we should still clear local state
      heartbeatService.stopHeartbeat();
      const { clearTokens } = useAuth.getState();
      clearTokens();
      queryClient.clear();
      throw new Error("Logout failed: " + error.message);
    }
  },

  async loginWithOtp(data) {
    try {
      const response = await api.post('/send-otp', {
        email: data.email
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async verifyOtp(data) {
    try {
      const response = await api.post('/verify-otp', {
        email: data.email,
        otp: data.otp
      });
      
      // Handle authentication similar to regular login
      const { data: responseData, meta } = response.data;
      const user = responseData.user.name;
      const userId = responseData.user.id;
      const accessToken = meta.access_token;
      const refreshToken = meta.refresh_token;
      const userRole = responseData.user.roles[0].title;
      
      const { setTokens, setUserRole } = useAuth.getState();
      setTokens(accessToken, refreshToken, userId);
      setUserRole(userRole);

      // Start heartbeat if user role is 'user'
      heartbeatService.startHeartbeat();

      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async resendOtp(email) {
    try {
      const response = await api.post('/send-otp', { email });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  requestPasswordReset(email) {
    return api.post('/v1/password/email', { email });
  },

  resetPassword(data) {
    return api.post('/v1/password/reset', data);
  }
};
